export type StatusId = "driving" | "ralenti" | "stopped" | "offline";

interface StatusMeta {
  dot: string;
  pillIdle: string;
  pillActive: string;
  accent: string;
}

export const STATUS_META = {
  driving: {
    dot: "bg-primary-500",
    pillIdle:
      "border-line bg-app text-content-secondary hover:border-primary-500/50 hover:bg-subtle",
    pillActive: "border-primary-500/50 bg-primary-500/10 text-primary-500",
    accent: "border-l-primary-500",
  },
  ralenti: {
    dot: "bg-warning",
    pillIdle:
      "border-line bg-app text-content-secondary hover:border-warning/50 hover:bg-subtle",
    pillActive: "border-warning/50 bg-warning/10 text-warning",
    accent: "border-l-warning",
  },
  stopped: {
    dot: "bg-error",
    pillIdle:
      "border-line bg-app text-content-secondary hover:border-error/50 hover:bg-subtle",
    pillActive: "border-error/50 bg-error/10 text-error",
    accent: "border-l-error",
  },
  offline: {
    dot: "bg-content-muted",
    pillIdle:
      "border-line bg-app text-content-secondary hover:border-line-soft hover:bg-subtle",
    pillActive: "border-line-soft bg-subtle text-content",
    accent: "border-l-content-muted",
  },
} as const satisfies Record<StatusId, StatusMeta>;

export const STATUS_ORDER = [
  "driving",
  "ralenti",
  "stopped",
  "offline",
] as const satisfies readonly StatusId[];

export const isStatusId = (value: string | null | undefined): value is StatusId =>
  !!value && value in STATUS_META;
